import { supportAdministrationPageState } from "service/shared/singletones/supportAdministrationPageService/supportAdministrationPage.state";

class Controller {
  public readonly state = supportAdministrationPageState;
}

export const supportAdministrationPageController = new Controller();
